import React from 'react';
import { connect } from 'dva';

import Document, { DocumentProps } from '../../shared/Document/Document';
import {
  childHasActivePassport,
  getActiveChildBirthCertificate,
} from '../../../selectors/child';
import { shouldHaveIdentification } from '../../../helpers/dateHelpers';
import { isForeignCitizen } from '../../../helpers/isForeignCitizen';
import { CHILD } from '../../../models/child';

function BirthCertificate(props: DocumentProps): JSX.Element {
  return (
    <div className="Document">
      <Document {...props} model={CHILD} />
    </div>
  );
}

function mapStateToProps(state) {
  const {
    child: { birthdate, citizenship, birthPlace },
  } = state;

  return {
    ...getActiveChildBirthCertificate(state),
    citizenship: citizenship.value,
    birthPlace,
    model: CHILD,
    showBirthPlace:
      !childHasActivePassport(state) && !isForeignCitizen(citizenship.value),
  };
}

export default connect(mapStateToProps)(BirthCertificate);
